module.exports = __webpack_public_path__ + "static/img/business73.02d9703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business73.png
// module id = WAnc
// module chunks = 9